<template>
  <div class="couponBox">
    <div class="couponSearch">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="活动名称">
          <el-input
            v-model="formInline.activityTitle"
            placeholder="活动名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="优惠券名称">
          <el-input
            v-model="formInline.couponTitle"
            placeholder="优惠券名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="formInline.check_status" placeholder="审核状态">
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核未通过" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="状态">
            <el-option label="开启" value="1"></el-option>
            <el-option label="关闭" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="searchBtn">查询</el-button>
    </div>
    <div class="couponTitle">
      <div class="title">
        优惠券列表
      </div>
      <div class="button">
        <el-button type="primary" @click="addCoupon">
          新增活动
        </el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
      v-loading="loading"
    >
      <el-table-column label="活动ID" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="活动名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="活动链接" align="center">
        <template slot-scope="scope">
          <div
            style="display: flex;justify-content: center;align-items: center;"
          >
            <el-button type="text" @click="goLink(scope.row)"> 链接 </el-button
            >|
            <el-button
              type="text"
              style="margin: 0;"
              @click="copyLink(scope.row)"
            >
              复制
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="活动时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.begin_time }}/ <br />{{ scope.row.end_time }}
        </template>
      </el-table-column>
      <el-table-column label="关联优惠券（码）" align="center">
        <template slot-scope="scope">
          {{ scope.row.coupon_id }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column label="创建人" align="center">
        <template slot-scope="scope">
          <span> {{ scope.row.admin_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          {{ checkStatus(scope.row.check_status) }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          {{ startStatus(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleIsDetail(scope.row)">
            详情
          </el-button>
          <el-button type="text" @click="handleDelete(scope.row)">
            删除
          </el-button>
          <el-button
            v-if="scope.row.status == 1"
            type="text"
            @click="handleEdit(scope.row)"
          >
            关闭
          </el-button>
          <el-button v-else type="text" @click="handleEdit(scope.row)">
            开启
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="totalPages > 10">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="page_size"
        :total="pageTotal"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 新增活动 -->
    <el-dialog
      title="新增活动"
      :visible.sync="activityDialogVisible"
      width="50%"
      center
    >
      <div class="nBuild-title">基本信息</div>
      <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm">
        <el-form-item label="活动名称" prop="title">
          <el-input
            v-model="form.title"
            type="text"
            placeholder="请填写券名称"
            maxlength="15"
            style="width:240px"
            show-word-limit
            >*</el-input
          >
        </el-form-item>

        <!-- <el-form-item label="活动头图" v-show="!form_show.image" >
          <el-image
            class="look-thumb"
            :src="form.image"
            :preview-src-list="[form.image]"
          >
            <div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div>
          </el-image>
          <el-button type="primary" class="ml10" @click="handleToFixed('image')"
            >修改</el-button
          >
        </el-form-item> -->
        <el-form-item label="活动头图" prop="image">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeImgUpload"
          >
            <img
              v-if="form.image"
              :src="form.image"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.image && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button type="primary" @click="handleFixedCancel('image')"
            >保存</el-button
          >
        </el-form-item>
        <el-form-item label="活动时间" prop="date">
          <el-date-picker
            class="handle-date mr10"
            v-model="form.date"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="dateChange()"
          >
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动规则" prop="extra">
          <el-input v-model="form.extra" type="textarea" style="width:300px">
            *
          </el-input>
        </el-form-item>
        <el-form-item label="关联优惠券" prop="couponDatas">
          <el-input
            v-if="couponDatas != ''"
            text="textarea"
            v-model="couponDatas"
          ></el-input>
          <el-button type="primary" @click="relevanceCoupon">添加</el-button>
        </el-form-item>
        <div style="padding:0 20px">
          <div class="border"></div>
        </div>
        <div class="nBuild-title">分享设置</div>
        <el-form-item label="分享标题" prop="share_title">
          <el-input v-model="form.share_title" type="text" style="width:300px">
            *
          </el-input>
        </el-form-item>
        <el-form-item label="分享摘要" prop="share_content">
          <el-input
            v-model="form.share_content"
            type="text"
            style="width:300px"
          >
            *
          </el-input>
        </el-form-item>

        <el-form-item label="分享缩略图" prop="share_image">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeShareImageUpload"
          >
            <img
              v-if="form.share_image"
              :src="form.share_image"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.share_image && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button type="primary" @click="handleFixedCancel('share_image')"
            >保存</el-button
          >
        </el-form-item>
        <!-- <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" style="width:300px">
            *
          </el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="width:160px;height: 40px;">
          预览
        </el-button>
        <el-button
          type="primary"
          @click="nBuildCoupon('ruleForm')"
          style="width:160px;height: 40px;"
        >
          确认提交
        </el-button>
      </span>
    </el-dialog>
    <!-- 删除优惠券 -->
    <el-dialog title="提示" :visible.sync="delDialog" width="30%">
      <span>确定要删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialog = false">取 消</el-button>
        <el-button type="primary" @click="delFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog title="提示" :visible.sync="shDialog" width="30%">
      <span style="margin-right:10px">审核是否通过</span>
      <el-select @change="shChange" v-model="shValue" placeholder="请选择">
        <el-option
          v-for="item in shData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-show="isShShow"
        style="margin-top:20px"
        type="textarea"
        placeholder="请输入未通过原因"
        v-model="auditFailed"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shDialog = false">取 消</el-button>
        <el-button type="primary" @click="shFn()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 关联优惠券 -->
    <el-dialog title="优惠券列表" :visible.sync="couponDialog" width="50%">
      <el-form :inline="true" :model="couponData" class="demo-form-inline">
        <el-form-item label="优惠券名称">
          <el-input
            v-model="couponData.title"
            placeholder="优惠券名称"
          ></el-input>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" @click="getCouponList">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        @selection-change="handleSelectionChange"
        tooltip-effect="dark"
        :data="couponTableData"
        style="width: 100%"
        v-loading="loadings"
        ref="usermultipleTable"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="优惠券ID"> </el-table-column>
        <el-table-column prop="title" label="优惠券名称"> </el-table-column>
      </el-table>
      <div class="pagination" v-if="coupon_totalPages > 10">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="couponCurrentPage"
          :page-size="coupon_page_size"
          :total="coupon_pageTotal"
          @current-change="handleCouponPageChange"
        ></el-pagination>
      </div>
      <div style="margin-top: 10px;">
        <el-button type="primary" @click="cancelSelectCoupon">
          取消
        </el-button>
        <el-button type="primary" @click="okSelectCoupon">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/knowledgeApiConfig";
import http2 from "../../../api/uploadApiConfig";
export default {
  data() {
    return {
      loadings: false,
      activity_url: "",
      couponCurrentPage: 1,
      coupon_totalPages: 1,
      coupon_pageTotal: 10,
      coupon_page_size: 10,
      coupon_page_index: 10,
      couponSelectIds: [],
      couponSelectName: [],
      couponDatas: "",
      couponDatas1: [],
      couponSelectData: [],
      couponTableData: [],
      couponData: {},
      couponDialog: false,
      isShShow: false,
      shDialog: false,
      shData: [
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 2,
          label: "审核失败",
        },
      ],
      shValue: 1,
      auditFailed: "",
      is_add: false,
      begin_time: "",
      end_time: "",
      color1: "#000",
      delDialog: false,
      uploading: false,
      loading: false,
      activity_id: "",
      currentPage: 1,
      totalPages: 1,
      pageTotal: 10,
      page_size: 10,
      page_index: 10,
      form_change: {},
      form_show: {},
      couponState: [
        {
          value: 1,
          label: "待领取",
        },
        {
          value: 2,
          label: "未使用",
        },
        {
          value: 3,
          label: "已使用",
        },
        {
          value: 4,
          label: "已过期",
        },
      ],
      couponStateValue: "",
      useTableData: [
        {
          collectionRate: "1",
          useRate: "2",
          totalTurnover: "3",
          preferentialAmount: "4",
        },
      ],
      form: {
        title: "", //活动标题
        image: "", //活动头图
        date: "", //活动时间
        begin_time: "", //活动开始时间
        end_time: "", //活动结束时间
        extra: "", //活动规则
        couponDatas: "", //关联优惠券
        share_title: "", //分享标题
        share_content: "", //分享摘要
        share_image: "", //分享缩略图
        remark: "", //备注
      },
      form1: {
        title: "", //活动标题
        image: "", //活动头图
        date: "", //活动时间
        begin_time: "", //活动开始时间
        end_time: "", //活动结束时间
        extra: "", //活动规则
        couponDatas: "", //关联优惠券
        share_title: "", //分享标题
        share_content: "", //分享摘要
        share_image: "", //分享缩略图
        remark: "", //备注
      },
      rules: {
        title: [
          { required: true, message: "请填写优惠券标题", trigger: "blur" },
        ],
        // image: [
        //   { required: true, message: "请上传活动头图", trigger: "change" },
        // ],
        extra: [{ required: true, message: "请填活动规则", trigger: "blur" }],
        share_title: [
          { required: true, message: "请填写分享标题", trigger: "blur" },
        ],
        share_content: [
          { required: true, message: "请填写分享摘要", trigger: "blur" },
        ],
        // share_image: [
        //   { required: true, message: "请上传分享缩略图", trigger: "change" },
        // ],
      },
      // 优惠券类型
      couponType: [
        { id: 1, name: "VIP" },
        { id: 2, name: "古籍" },
      ],
      vipTypeNumber: 1,
      // 会员类型
      vipList: [],
      // 优惠方式
      preferentialMethod: [
        { id: 1, name: "满减" },
        { id: 2, name: "折扣" },
        { id: 3, name: "无门槛" },
      ],
      // 用户类型
      userTypeList: [
        { id: "all", name: "所有用户" },
        { id: "new_register", name: "仅新注册用户" },
        { id: "vip", name: "仅会员" },
        { id: "not_vip", name: "仅非会员" },
        // { id: 3, name: "复购3次" },
        // { id: 3, name: "复购10次" },
      ],
      // 是否叠加
      compositionList: [
        { id: 1, name: "可叠加" },
        { id: 2, name: "不可叠加" },
      ],
      preferentialMethodNumber: "",
      activityDialogVisible: false,
      changeDialogVisible: false,
      userDetailDialog: false,
      abolishDialog: false,
      closeDialog: false,
      openDialog: false,
      formInline: {},
      page: {
        index: 1,
        size: 10,
        total: 0,
      },
      tableData: [],
      options: [
        { value: "1", label: "域外古籍", children: [] },
        { value: "2", label: "基础古籍", children: [] },
        { value: "3", label: "孤本古籍", children: [] },
      ],
      bookIdData: [],
      CoupontableData: [],
      coupon_id: "",
      coupon_ids: "",
    };
  },
  mounted() {
    this.onSubmit();
  },
  methods: {
    // 分页导航
    handleCouponPageChange(val) {
      console.log(val);
      this.bookSelectData = val;
    },
    handleSelectionChange(val) {
      console.log(val);
      this.couponSelectData = val;
    },
    cancelSelectCoupon() {
      this.couponDialog = false;
    },
    okSelectCoupon() {
      console.log(this.couponDatas1, "couponDatas1");
      this.couponSelectIds = [];
      this.couponSelectName = [];
      for (let i = 0; i < this.couponSelectData.length; i++) {
        this.couponSelectIds.push(this.couponSelectData[i].id);
        this.couponSelectName.push(this.couponSelectData[i].title);
      }
      this.couponDatas1 = this.couponDatas1.concat(this.couponSelectData);
      this.couponDatas = this.couponSelectName.toString();
      this.couponDialog = false;
    },
    // 优惠券列表
    getCouponList() {
      let params = {
        page_size: this.page.size,
        page: this.couponCurrentPage,
        title: this.couponData.title,
        activity_id: this.activity_id,
      };
      this.loadings = true;
      http.get("admin/coupon/select_coupons", { params }).then((res) => {
        if (res.data.status_code == 200) {
          if (res.data.status_code == 200) {
            let data = res.data.data.data;
            this.couponTableData = data;
            this.CoupontableData = data;
            this.couponCurrentPage = Number(res.data.data.current_page);
            this.coupon_totalPages = res.data.data.total;
            this.coupon_pageTotal = this.totalPages * this.page_size;
            this.toggleSelection();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    toggleSelection() {
      if (this.couponDatas == "") {
        this.loadings = false;
      } else {
        for (let i = 0; i < this.CoupontableData.length; i++) {
          for (let j = 0; j < this.couponDatas1.length; j++) {
            setTimeout(() => {
              this.loadings = false;
              if (this.couponDatas1[j].id == this.CoupontableData[i].id) {
                this.$nextTick(() => {
                  this.$refs.usermultipleTable.toggleRowSelection(
                    this.CoupontableData[i],
                    true
                  );
                });
              }
            }, 500);
          }
        }
      }
    },
    relevanceCoupon() {
      this.couponDialog = true;
      this.getCouponList();
    },
    shFn() {
      if (this.isShShow == false) {
        let params = {
          status: 1,
        };
        http
          .put("admin/coupon/active_check/" + this.activity_id, params)
          .then((res) => {
            if (res.data.status_code == 200) {
              this.onSubmit();
              this.shDialog = false;
              this.$message.success("审核成功");
            } else {
              this.shDialog = false;
              this.$message.error(res.data.msg);
            }
          });
      } else {
        let params = {
          status: 2,
          remark: this.auditFailed,
        };
        http
          .put("admin/coupon/active_check/" + this.activity_id, params)
          .then((res) => {
            if (res.data.status_code == 200) {
              this.onSubmit();
              this.shDialog = false;
              this.$message.success("审核成功");
            } else {
              this.shDialog = false;
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    shChange(e) {
      console.log(e, "e");
      if (e == 2) {
        this.isShShow = true;
      } else {
        this.isShShow = false;
      }
    },
    // 优惠券审核
    handleExamine(row) {
      this.shDialog = true;
      this.activity_id = row.id;
      console.log(row, "row");
    },
    onSubmit() {
      this.formInline["page_size"] = this.page.size;
      this.formInline["page"] = this.currentPage;
      http
        .get("admin/coupon/activity/list", { params: this.formInline })
        .then((res) => {
          if (res.data.status_code == 200) {
            this.tableData = res.data.data.data;
            this.currentPage = res.data.data.current_page;
            this.totalPages = res.data.data.total;
            this.pageTotal = this.totalPages * this.page_size;
            this.loading = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 分页导航
    handlePageChange(val) {
      console.log(val);
      this.currentPage = val;
      this.onSubmit();
    },
    // 删除
    handleDelete(row) {
      let that = this;
      http.delete("admin/coupon/activity/delete/" + row.id).then(function(res) {
        if (res.data.status_code == 200) {
          that.$message.success("删除成功");
          that.onSubmit();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 开启关闭
    handleEdit(row) {
      let that = this;
      if (row.status == 1) {
        http
          .put("admin/coupon/activity/operation/" + row.id)
          .then(function(res) {
            if (res.data.status_code == 200) {
              that.$message.success("关闭成功");
              that.onSubmit();
            } else {
              that.$message.error(res.data.msg);
            }
          });
      } else {
        http
          .put("admin/coupon/activity/operation/" + row.id)
          .then(function(res) {
            if (res.data.status_code == 200) {
              that.$message.success("启用成功");
              that.onSubmit();
            } else {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    // 详情
    handleIsDetail(row) {
      this.activity_id = row.id;
      this.form_show.image = true;
      this.form_show.share_image = true;
      this.is_add = false;
      this.form = {
        id: row.id,
        title: row.title, //活动标题
        image: row.image, //活动头图
        begin_time: row.begin_time,
        end_time: row.end_time,
        extra: row.extra, //活动规则
        relevance_coupon: row.relevance_coupon, //关联优惠券
        share_title: row.share_title, //分享标题
        share_content: row.share_content, //分享摘要
        share_image: row.share_image, //分享缩略图
        remark: row.remark, //备注
      };
      console.log(this.form, "form");
      this.activityDialogVisible = true;

      http.get("admin/coupon/activity/info/" + row.id).then((res) => {
        if (res.data.status_code == 200) {
          console.log(res, "res");
          let data = res.data.data;
          this.form.image_path = data.image_path;
          this.form.share_image_path = data.share_image_path;
          this.$set(this.form, "date", [data.begin_time, data.end_time]);
          let arr = [];
          this.couponDatas1 = data.coupon_list;
          this.coupon_ids = data.coupon_id;
          for (let i = 0; i < this.couponDatas1.length; i++) {
            arr.push(this.couponDatas1[i].title);
          }
          this.couponDatas = arr.toString();
          console.log(this.couponDatas, "couponDatas");
        }
      });
    },
    // 审核状态
    checkStatus(type) {
      if (type == 1) {
        return "审核通过";
      } else if (type == 2) {
        return "审核失败";
      } else if (type == 0) {
        return "待审核";
      }
    },
    // 状态
    startStatus(type) {
      if (type == 1) {
        return "开启";
      } else if (type == 2) {
        return "关闭";
      }
    },
    // 查询
    searchBtn() {
      let that = this;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
        title: that.formInline.activityTitle,
        coupon_title: that.formInline.couponTitle,
        check_status: that.formInline.check_status,
        status: that.formInline.status,
      };
      http
        .get("admin/coupon/activity/list", { params: params })
        .then(function(res) {
          that.tableData = res.data.data;
          that.currentPage = 1;
          that.totalPages = res.data.data.total_pages;
          that.pageTotal = that.totalPages * that.page_size;
          that.loading = false;
        });
    },
    // 链接
    goLink(row) {
      if (process.env.NODE_ENV === "development") {
        location.href =
          "http://proxy.jiankanghao.net:50290/pages/activityCenter/activityDetail?activity_id=" +
          row.id;
      } else {
        location.href =
          "https://m.zhongyigen.com/pages/activityCenter/activityDetail?activity_id" +
          row.id;
      }
    },
    // 复制
    copyLink(row) {
      if (process.env.NODE_ENV === "development") {
        this.activity_url =
          "http://proxy.jiankanghao.net:50290/pages/activityCenter/activityDetail?activity_id=" +
          row.id;
        this.$copyText(this.activity_url).then(
          (e) => {
            console.log("复制成功：", e);
          },
          (e) => {
            console.log("复制失败：", e);
          }
        );
      } else {
        this.activity_url =
          "https://m.zhongyigen.com/pages/activityCenter/activityDetail?activity_id=" +
          row.id;
        this.$copyText(this.activity_url).then(
          (e) => {
            console.log("复制成功：", e);
          },
          (e) => {
            console.log("复制失败：", e);
          }
        );
      }
    },
    dateChange() {
      console.log(this.form.date, "e");
      this.form.begin_time = this.form.date[0];
      this.form.end_time = this.form.date[1];
    },
    // 活动头图
    beforeImgUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", `activity/image`);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.image_path = `activity/image/` + filename;
            that.form.image = URL.createObjectURL(file);
            // that.putDoctor("image_path", that.form.image_path, false);
            that.$set(that.form_show, "image", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 分享缩略图
    beforeShareImageUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", `activity/share_image`);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.share_image_path = `activity/share_image/` + filename;
            that.form.share_image = URL.createObjectURL(file);
            // that.putDoctor("image_path", that.form.image_path, false);
            that.$set(that.form_show, "share_image", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleToFixed(key) {
      let that = this;
      that.form_change = {};
      that.form_change[key] = that.form[key];
      that.$set(that.form_show, key, true);
      that.$forceUpdate();
    },
    handleFixedCancel(key) {
      this.$set(this.form_show, key, false);
      this.$forceUpdate();
    },
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    getPlatformName(id) {
      var item = _.filter(this.platform_types, function(selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    // 查看领取详情
    getUseDetail() {
      this.userDetailDialog = true;
    },
    addCoupon() {
      this.activity_id = "";
      this.couponSelectIds = [];
      this.couponSelectName = [];
      this.couponDatas = "";
      this.is_add = true;
      this.activityDialogVisible = true;
      this.form = {
        title: "", //活动标题
        image_path: "", //活动头图
        background_color: "", //活动背景色
        date: "", //活动时间
        extra: "", //活动规则
        relevance_coupon: "", //关联优惠券
        share_title: "", //分享标题
        share_content: "", //分享摘要
        share_image_path: "", //分享缩略图
        coupon_ids: "",
        remark: "", //备注
      };
    },
    // 新增优惠券
    nBuildCoupon(formName) {
      //console.log(this.form);
      let that = this;
      console.log(that.form, "that.form");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.form.image_path == "") {
            that.$message.error("请上传活动头图");
          } else if (that.form.share_image_path == "") {
            that.$message.error("请上传活动分享缩略图");
          } else if (that.form.begin_time == undefined) {
            that.$message.error("请选择活动时间");
          } else {
            let params = {
              title: that.form.title,
              extra: that.form.extra,
              image: that.form.image_path,
              begin_time: that.form.begin_time,
              end_time: that.form.end_time,
              share_title: that.form.share_title,
              remark: that.form.remark,
              share_content: that.form.share_content,
              share_image: that.form.share_image_path,
              coupon_ids:
                this.couponSelectIds.length != 0
                  ? this.couponSelectIds.toString()
                  : this.coupon_ids,
            };
            if (that.is_add) {
              http.post("admin/coupon/activity/add", params).then((res) => {
                if (res.data.status_code == 200) {
                  that.$message.success("新增成功");
                  that.activityDialogVisible = false;
                  that.onSubmit();
                  //console.log(res.data.data, "data");
                }
              });
            } else {
              http
                .put("admin/coupon/activity/edit/" + that.form.id, params)
                .then(function(res) {
                  // console.log(res);
                  if (res.data.status_code == 200) {
                    that.$message.success(`修改成功`);
                    that.activityDialogVisible = false;
                    that.onSubmit();
                  } else {
                    that.$message.error(res.data.msg);
                  }
                });
            }
          }
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    // 废止优惠券
    abolish(row) {
      this.abolishDialog = true;
      this.coupon_id = row.id;
    },
    // 确认是否废止
    abolishFn() {
      http.put("admin/coupon/fz/" + this.coupon_id).then((res) => {
        if (res.data.status_code == 200) {
          this.abolishDialog = false;
          this.onSubmit();
          this.$message.success("优惠券已废止");
        } else {
          return false;
        }
      });
    },
    // 关闭优惠券
    close(row) {
      this.closeDialog = true;
      this.coupon_id = row.id;
    },
    // 确认是否关闭
    closeFn() {
      http.put("admin/coupon/operation/" + this.coupon_id).then((res) => {
        if (res.data.status_code == 200) {
          this.closeDialog = false;
          this.onSubmit();
          this.$message.success("优惠券已关闭");
        } else {
          this.closeDialog = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开优惠券
    open(row) {
      this.openDialog = true;
      this.coupon_id = row.id;
    },
    // 确认是否打开
    openFn() {
      http.put("admin/coupon/operation/" + this.coupon_id).then((res) => {
        if (res.data.status_code == 200) {
          this.abolishDialog = false;
          this.onSubmit();
          this.$message.success("优惠券已打开");
        } else {
          this.abolishDialog = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    // 选择优惠方式
    selectpreferentialMethod(e) {
      if (e == 1) {
        this.preferentialMethodNumber = 1;
      } else if (e == 2) {
        this.preferentialMethodNumber = 2;
      } else if (e == 3) {
        this.preferentialMethodNumber = 3;
      }
    },
    //类型转换
    goodsType(type) {
      if (type == 1) {
        return "vip";
      } else if (type == 2) {
        return "古籍";
      }
    },
    youhuifangshi(row) {
      console.log(row);
      if (row.favourable_type == 1) {
        return "满" + row.satisfy + " " + "减" + row.amount;
      }
      if (row.favourable_type == 2) {
        return row.discount + "折";
      }
      if (row.favourable_type == 3) {
        return "减" + row.amount;
      }
    },
    //审核状态
    status(type) {
      if (type == 1) {
        return "审核通过";
      } else if (type == 2) {
        return "审核失败";
      }
    },
    // 使用状态
    useStatus(type) {
      if (type == 1) {
        return "正常";
      } else if (type == 2) {
        return "关闭";
      } else if (type == 3) {
        return "废止";
      }
    },
    delFn() {
      http
        .delete("admin/coupon/activity/delete/" + this.activity_id)
        .then((res) => {
          if (res.data.status_code == 200) {
            this.delDialog = false;
            this.onSubmit();
            this.$message.success("删除成功");
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.couponBox {
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
  .couponSearch {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /deep/button {
      margin-bottom: 20px;
    }
  }
  .couponTitle {
    width: 100%;
    height: 60px;
    line-height: 60px;
    .title {
      float: left;
      font-size: 22px;
      font-weight: bold;
    }
    .button {
      float: right;
    }
  }
}
.nBuild-title {
  padding: 20px;
  color: #169bd5;
}
.border {
  width: 100%;
  height: 1px;
  margin: 10px 0;
  background-image: linear-gradient(
    to right,
    rgb(121, 121, 121) 0%,
    rgb(121, 121, 121) 50%,
    transparent 50%
  );
  background-size: 20px 2px;
  background-repeat: repeat-x;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border: 1px solid #000;
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.couponStateBox {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.couponState {
  display: flex;
  align-items: center;
}
.look-thumb {
  display: block;
  width: 178px;
  height: 178px;
}
.avatar {
  width: 178px;
  height: 178px;
  line-height: 178px;
  display: block;
  max-width: 100%;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.center {
  display: flex;
  align-items: center;
}
/deep/.ml10 {
  margin: 0 !important;
  margin-top: 15px !important;
}
</style>
